import {LogFilter} from "./log-filter.model";

export class CategoryLogFilter extends LogFilter {}
